import gql from 'graphql-tag';

export const getCategories = gql`
  query getCategories($active: Boolean, $tenantId: Int!) {
    getCategories(active: $active, tenantId: $tenantId) {
      id
      name
      image
    }
  }
`;
